export interface ICOLORS extends Record<keyof typeof LIGHT_COLORS, string> {}

export const LIGHT_COLORS = {
  PRIMARY: '#F18926',
  PRIMARY_LIGHT: '#FDF2E7',
  SECONDARY: '#CED0D4',
  TERTIARY: '#F2F3F7',
  BORDER: '#EAEAEC',
  BORDER_INPUT: '#D9D9D9',
  GRAY_LIGHT: '#ebedf2',
  GRAY_LIGHTER: '#f0f2f5',
  PAGE_BG: '#D9DBE0',
  DANGER: '#ea2440',
  BLUE: '#3b86e0',
  LINK: '#1890FF',
  GREEN: '#49ba69',
  DARKBLUE: '#0f2137',
  TEXT1: '#212121',
  TEXT2: '#424242',
  TEXT3: '#616161',
  TEXT4: '#9E9E9E',
  TEXT5: '#BDBDBD',
  CHAT_AUDIO_BG: '#E2AA5D',
  ICON: '#4A4A59',
  BACKGROUND: '#FFFFFF',
  SURFACE_PAGE: '#F7F8FA',
  SHADOW: '#000000',
  SKELETON_BG: '#dedede',
  SKELETON_HIGHLIGHT: '#f7f7f7',
  CREATOR_LABEL: '#F5CB52',
  BOX_SHADOW: 'rgba(0, 0, 0, 0.1)',
  WHITE: '#ffffff',

  INFO: '#1890FF',
  INFO_ALT: '#3480eb',
  INFO_FILL: '#E8F4FF',
  INFO50: '#e8f4ff',
  INFO100: '#dceeff',
  INFO200: '#8cc8ff',
  INFO300: '#46a6ff',
  INFO400: '#1890FF',
  INFO500: '#1373cc',
  INFO600: '#0e5699',
  INFO700: '#0a3a66',
  INFO800: '#062440',

  SUCCESS: '#00A400',
  SUCCESS_FILL: '#E6F6E6',
  SUCCESS50: '#e6f6e6',
  SUCCESS100: '#d9f1d9',
  SUCCESS200: '#80d280',
  SUCCESS300: '#33b633',
  SUCCESS400: '#00A400',
  SUCCESS500: '#008300',
  SUCCESS600: '#006200',
  SUCCESS700: '#004200',
  SUCCESS800: '#002900',

  WARNING: '#F5CB52',
  WARNING_FILL: '#FEFAEE',
  WARNING50: '#fefaee',
  WARNING100: '#fef7e5',
  WARNING200: '#fae5a9',
  WARNING300: '#f7d575',
  WARNING400: '#F5CB52',
  WARNING500: '#c4a242',
  WARNING600: '#937a31',
  WARNING700: '#625121',
  WARNING800: '#3d3315',

  ERROR: '#EA2440',
  ERROR_FILL: '#FDE9EC',
  ERROR50: '#fde9ec',
  ERROR100: '#fcdee2',
  ERROR200: '#f592a0',
  ERROR300: '#ee5066',
  ERROR400: '#EA2440',
  ERROR500: '#bb1d33',
  ERROR600: '#8c1626',
  ERROR700: '#5e0e1a',
  ERROR800: '#3b0910',

  PURPLE: '#5746AF',
  PURPLE_FILL: '#eeedf7',
  PURPLE50: '#eeedf7',
  PURPLE100: '#e6e3f3',
  PURPLE200: '#aba3d7',
  PURPLE300: '#796bbf',
  PURPLE400: '#5746AF',
  PURPLE500: '#46388c',
  PURPLE600: '#342a69',
  PURPLE700: '#231c46',
  PURPLE800: '#16122c',

  SHORT_DURATION: '0.2s',
};

export const DARK_COLORS: ICOLORS = {
  PRIMARY: '#F18926',
  PRIMARY_LIGHT: '#F1892620',
  SECONDARY: '#0a192f',
  TERTIARY: '#2a3d5e',
  BORDER: '#152745',
  BORDER_INPUT: '#FFFFFF99',
  GRAY_LIGHT: '#112240',
  GRAY_LIGHTER: '#233554',
  PAGE_BG: '#262e47',
  DANGER: '#ea2440',
  BLUE: '#3b86e0',
  LINK: '#1890FF',
  GREEN: '#49ba69',
  DARKBLUE: '#8892b0',
  TEXT1: '#e6f1ff',
  TEXT2: '#ccd6f6',
  TEXT3: '#a8b2d1',
  TEXT4: '#8892b0',
  TEXT5: '#495670',
  CHAT_AUDIO_BG: '#E2AA5D',
  ICON: '#cad1eb',
  BACKGROUND: '#020c1b',
  SURFACE_PAGE: '#080707',
  SHADOW: '#f0f5fc',
  SKELETON_BG: '#2a3657',
  SKELETON_HIGHLIGHT: '#3e547a',
  CREATOR_LABEL: '#0a192f',
  BOX_SHADOW: 'rgba(0, 0, 0, 0.1)',
  WHITE: '#ffffff',

  INFO: '#1890FF',
  INFO_ALT: '#3480eb',
  INFO_FILL: '#E8F4FF',
  INFO50: '#e8f4ff',
  INFO100: '#dceeff',
  INFO200: '#8cc8ff',
  INFO300: '#46a6ff',
  INFO400: '#1890FF',
  INFO500: '#1373cc',
  INFO600: '#0e5699',
  INFO700: '#0a3a66',
  INFO800: '#062440',

  SUCCESS: '#00A400',
  SUCCESS_FILL: '#E6F6E6',
  SUCCESS50: '#e6f6e6',
  SUCCESS100: '#d9f1d9',
  SUCCESS200: '#80d280',
  SUCCESS300: '#33b633',
  SUCCESS400: '#00A400',
  SUCCESS500: '#008300',
  SUCCESS600: '#006200',
  SUCCESS700: '#004200',
  SUCCESS800: '#002900',

  WARNING: '#F5CB52',
  WARNING_FILL: '#FEFAEE',
  WARNING50: '#fefaee',
  WARNING100: '#fef7e5',
  WARNING200: '#fae5a9',
  WARNING300: '#f7d575',
  WARNING400: '#F5CB52',
  WARNING500: '#c4a242',
  WARNING600: '#937a31',
  WARNING700: '#625121',
  WARNING800: '#3d3315',

  ERROR: '#EA2440',
  ERROR_FILL: '#FDE9EC',
  ERROR50: '#fde9ec',
  ERROR100: '#fcdee2',
  ERROR200: '#f592a0',
  ERROR300: '#ee5066',
  ERROR400: '#EA2440',
  ERROR500: '#bb1d33',
  ERROR600: '#8c1626',
  ERROR700: '#5e0e1a',
  ERROR800: '#3b0910',

  PURPLE: '#5746AF',
  PURPLE_FILL: '#eeedf7',
  PURPLE50: '#eeedf7',
  PURPLE100: '#e6e3f3',
  PURPLE200: '#aba3d7',
  PURPLE300: '#796bbf',
  PURPLE400: '#5746AF',
  PURPLE500: '#46388c',
  PURPLE600: '#342a69',
  PURPLE700: '#231c46',
  PURPLE800: '#16122c',

  SHORT_DURATION: '0.2s',
};

export const CHAT_NAME_COLORS = [
  '#ffbc38',
  '#ff72a1',
  '#fc9775',
  '#25d366',
  '#a5b337',
  '#42c7b8',
  '#f15c6d',
  '#15A0DA',
  '#e91e63',
  '#5856D6',
  '#FF3B30',
] as const;
